module.exports = "/call-frontend/img/bg_login_light.3bc2de1f.png";